export default __webpack_public_path__ + "static/karate-23d0232db21bdd9915402be24f1ae77c.jpg";